import React from 'react';
import PropTypes from 'prop-types';


const IconTrendComment = ({ width = '16px', height = '16px', color = '#1F1F1F' }) => {
    return <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M0 1V10C0 10.5304 0.210714 11.0391 0.585786 11.4142C0.960859 11.7893 1.46957 12 2 12H7V15H8.91L12.17 12H14C14.5304 12 15.0391 11.7893 15.4142 11.4142C15.7893 11.0391 16 10.5304 16 10V1H0ZM9 12.2V10H2V3H14V10H11.39L9 12.2Z' fill={color} />
    </svg>;
};

IconTrendComment.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string,
};

export default IconTrendComment;
